import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
// hooks
//import useAuth from "../hooks/useAuth";

// ----------------------------------------------------------------------

export default function GuestGuard({ children }: any) {
  const { isAuthenticated } = useAuth();
  console.log("isAuthenticated", isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to={"/dashboard/app"} />;
  }

  return <>{children}</>;
}
